
import { CategoryColor, IEvent } from "../../app/modules/Dashboard/calendar/core/type";
import { StoreAction } from "../../utils/actions";

/** State type */
interface eventState {
    eventData: IEvent[] | null;
    categoryAndColorsData: CategoryColor[] | null;
    isEventDataLoaded: boolean;
    isCategoryAndColorsDataLoaded: boolean;
}

/** Action type */
interface NotificationAction {
    type: string;
    payload: CategoryColor[] | IEvent[] | IEvent | number | null;
}

const initialState: eventState = {
    eventData: [],
    categoryAndColorsData: [],
    isEventDataLoaded: false,
    isCategoryAndColorsDataLoaded: false,
};

export default function eventReducer(
    state: eventState = initialState,
    action: NotificationAction
): eventState {

    switch (action.type) {

        //  Replace full list
        case StoreAction.FETCH_EVENTS:
            return {
                ...state,
                eventData: action.payload as IEvent[],
                isEventDataLoaded: true
            };

        //  Add single
        case StoreAction.ADD_EVENT:
            return {
                ...state,
                eventData: [
                    action.payload as IEvent,
                    ...(state.eventData || []),
                ],
            };

        //  Delete by id
        case StoreAction.DELETE_EVENT:
            return {
                ...state,
                eventData: (state.eventData || []).filter(
                    (item) => item.event_id !== action.payload
                ),
            };

        //  Update by id
        case StoreAction.UPDATE_EVENT:
            return {
                ...state,
                eventData: (state.eventData || []).map((item) =>
                    item.event_id === (action.payload as IEvent).event_id
                        ? { ...item, ...(action.payload as IEvent) }
                        : item
                ),
            };

        //  Replace full list
        case StoreAction.FETCH_EVENT_CATEGORY_AND_COLORS:
            return {
                ...state,
                categoryAndColorsData: action.payload as CategoryColor[],
                isCategoryAndColorsDataLoaded: true
            };

        default:
            return state;
    }
}
